import { css } from "@emotion/css";
import { resetStyles } from "@octopusdeploy/design-system-components";
import { ExclamationCircleIcon, XmarkIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, space, colorScales, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { OctopusError } from "@octopusdeploy/octopus-server-client";
import React from "react";
interface ErrorAlertProps {
    error: Error;
    onClose: () => void;
    accessibleName: string;
}
export function ErrorAlert({ error, onClose, accessibleName }: ErrorAlertProps) {
    const isOctopusError = OctopusError.isOctopusError(error);
    const title = isOctopusError ? error.ErrorMessage : error.message;
    const details = isOctopusError ? error.Errors : undefined;
    return (<div className={containerStyles} role="alert" aria-label={accessibleName}>
            <ExclamationCircleIcon size={24} color={themeTokens.color.icon.danger}/>
            <p className={errorTitleStyles}>{title}</p>
            <button className={closeAlertButtonStyles} onClick={onClose} aria-label={`Close ${accessibleName} alert`}>
                <XmarkIcon size={24}/>
            </button>
            {details && details.length > 0 && (<div className={errorDetailContainerStyles}>
                    {details.map((detail, index) => (<p className={errorDetailStyles} key={index}>
                            {detail}
                        </p>))}
                </div>)}
        </div>);
}
const accentWidth = space[8];
const accentColor = colorScales.red[500];
const backgroundColor = colorScales.red[100];
const containerStyles = css({
    display: "grid",
    width: "100%",
    boxSizing: "border-box",
    padding: space[16],
    gap: space[8],
    borderRadius: borderRadius.large,
    background: `linear-gradient(90deg, ${accentColor} 0, ${accentColor} ${accentWidth}, ${backgroundColor} ${accentWidth}, ${backgroundColor} 100%)`,
    gridTemplateColumns: "auto 1fr auto",
});
const errorTitleStyles = css({
    ...resetStyles.paragraph,
    font: text.regular.bold.large, // TODO: use text.alert.title when available
    color: colorScales.red[600],
});
const errorDetailContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space[8],
    gridColumn: 2,
});
const errorDetailStyles = css({
    ...resetStyles.paragraph,
    font: text.regular.default.large, // TODO: use text.alert.body when available
    color: colorScales.navy[900],
});
const closeAlertButtonStyles = css({
    ...resetStyles.button,
    display: "flex",
});
